import { Container } from './styles'

import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'
import whatsapp from '../../assets/whatsapp.svg'

import instagramIcon from '../../assets/instagram.svg'

export function Footer() {
  return (
    <Container className="footer">

      <div className="social-media">
        <a
          href="https://www.linkedin.com/in/karthik-krishna-m/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={linkedin} alt="Linkedin" />
        </a>
        <a
          href="https://github.com/mkk-1817/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>
        <a
          href={`https://api.whatsapp.com/send/?phone=${process.env.REACT_APP_PHONE_NUMBER?.replace('+', '%2B')}&text=Hello+Karthik+I+found+your+contact+through+portfolio+site.%0A%0A`}
          target="_blank"
          rel="noreferrer"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
        <a
          href="https://www.instagram.com/_karthi18_"
          target="_blank"
          rel="noreferrer"
        >
          <img src={instagramIcon} alt="Instagram" />
        </a>
      </div>
    </Container>
  )
}
